import type { IconDefinition } from '../index.tsx';

export const iconPlayCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconPlayCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.5 4H6V12H7.5L11.5 8L7.5 4Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
